import React, { useEffect } from 'react';
import lostGif from 'assets/images/lost.gif';
import logo from 'assets/images/logo.jpg';
import { Link } from 'react-router-dom';
import { ROUTES } from '@lsgo/lsgo-common/constants/routes';
import posthog from 'posthog-js';

function errorToAnalyticsString(value) {
    if (value instanceof Error) {
        return JSON.stringify({
            name: value.name,
            message: value.message,
            stack: value.stack,
        });
    }
    if (value !== null && typeof value === 'object') {
        try {
            return JSON.stringify(value);
        } catch {
            return String(value);
        }
    }
    return String(value);
}

export default function Page404({ error }) {
    useEffect(() => {
        if (!error) return;

        try {
            const href = window.location && window.location.href ? window.location.href : 'unknown';

            posthog.capture('page_404_error_rendered', {
                surface: 'teacher',
                href,
                pathname: window.location && window.location.pathname,
                search: window.location && window.location.search,
                referrer: document && document.referrer,
                error: errorToAnalyticsString(error),
            });
        } catch (e) {
            console.log('error', e);
        }
    }, [error]);

    return (
        <div
            style={{
                width: '100%',
                height: '100vh',
                background: '#ccc url(' + lostGif + ') no-repeat center bottom',
                backgroundSize: 'cover',
                display: 'flex',
                alignItems: 'center',
                alignContent: 'center',
            }}
        >
            <div
                style={{
                    width: '100%',
                    maxWidth: '500px',
                    margin: '0 auto',
                    padding: 80,
                    backgroundColor: 'rgba(204,204,204,0.8)',
                    textAlign: 'center',
                    borderRadius: 4,
                }}
            >
                <div>
                    <img src={logo} style={{ maxHeight: '140px' }} />
                </div>
                {!error ? (
                    <h3>
                        It seems like you are lost. Go back to <Link to={ROUTES.TEACHER.DASHBOARD.path}>Dashboard</Link>
                    </h3>
                ) : (
                    <h3>
                        Oops. There was an error. Go back to <Link to={ROUTES.TEACHER.DASHBOARD.path}>Dashboard</Link>.
                    </h3>
                )}
            </div>
        </div>
    );
}
